module.exports = __webpack_public_path__ + "img/m-banner-6m.5c53fcbf.png";